import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  clearAutomationOutput,
  selectLibrary,
} from "../../library/librarySlice";

export default function AutomationOutputModal() {
  const dispatch = useAppDispatch();
  const librarySlice = useAppSelector(selectLibrary);

  const handleClose = () => {
    dispatch(clearAutomationOutput());
  };

  return (
    <Dialog
      open={librarySlice.automationOutput !== undefined}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Automation Output</DialogTitle>
      <DialogContent>
        <Box sx={{ p: 2 }}>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              margin: 0,
              padding: "10px",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
              fontFamily: "monospace",
              fontSize: "14px",
              maxHeight: "70vh",
              overflow: "auto",
            }}
          >
            {librarySlice.automationOutput}
          </pre>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
